import { render } from "./CorporateBranding.vue?vue&type=template&id=f2980770&scoped=true"
import script from "./CorporateBranding.vue?vue&type=script&lang=js"
export * from "./CorporateBranding.vue?vue&type=script&lang=js"

import "./corporate-branding.scss?vue&type=style&index=0&id=f2980770&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2980770"]])

export default __exports__